import * as React from 'react';
import { graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';

import Layout from '../layout/layout';
import PageBuilder from '../components/page-builder';
import MediaItem from '../components/media-item';
import WildLogo from '../svg/logo-wild';

const JungleMedia = ({ data }) => {
	const page = data.page;
	const seo = page.seo;
	return (
		<Layout page={{
			slug: "/the-wild",
			breadcrumb: [{
				"@type": "ListItem",
				position: 2,
				name: "The Wild",
				item: "https://www.junglecreations.com/the-wild",
			 }]
		}}>
			<HelmetDatoCms seo={seo} />
			<main className='sb-wild'>
				<section className={`page-hero sb-hero s-lg p-lg bg-black`}>
					<div
						className={`scrim bg-black`}
						style={{ opacity: '16%' }}
					/>
					<div className='hero-media'>
						<MediaItem data={page.heroMedia} size='full' />
					</div>
					<WildLogo />
				</section>
				<PageBuilder data={page.builder} />
			</main>
		</Layout>
	);
};

export default JungleMedia;

export const query = graphql`
	query {
		page: datoCmsSubbrandWild {
			heroMedia {
				... on DatoCmsVideo {
					...Video
				}
				... on DatoCmsImage {
					...Image
				}
			}
			builder {
				__typename
				... on DatoCmsText {
					...TextBlock
				}
				... on DatoCmsCalloutText {
					...CalloutText
				}
				... on DatoCmsSingle {
					...Single
				}
				... on DatoCmsImageGrid {
					...ImageGrid
				}
				... on DatoCmsMediaContent {
					...MediaContent
				}
				... on DatoCmsMediaContentGrid {
					...MediaContentGrid
				}
				... on DatoCmsCarousel {
					...ImageCarousel
				}
				... on DatoCmsClientCarousel {
					...ClientCarousel
				}
				... on DatoCmsPrincipleCallout {
					...PrincipleCallout
				}
				... on DatoCmsServicesBlock {
					...ServicesBlock
				}
				... on DatoCmsResult {
					...Results
				}
				... on DatoCmsErgCarousel {
					...ErgCarousel
				}
				... on DatoCmsSubbrand {
					...SubbrandCallout
				}
				... on DatoCmsWorkCarousel {
					...WorkCarousel
				}
				... on DatoCmsRecentInsight {
					...RecentInsight
				}
			}
			seo: seoMetaTags {
				...GatsbyDatoCmsSeoMetaTags
			}
		}
	}
`;
